import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import { DateTime } from "luxon";
import { calcPosition, calcWidth } from "../../../../utils/TijdlijnDateCalcUtils";
import styles from "./VoorNaTijd.module.css";

interface IVoorNaTijd {
  isVoorTijd?: boolean;
  startTijd: DateTime;
  eindTijd: DateTime;
  scale: number;
}

export function VoorNaTijd({
  isVoorTijd = false,
  startTijd,
  eindTijd,
  scale,
}: Readonly<IVoorNaTijd>) {
  const timeLineBegin = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const timeLineEnd = useSelectedTimeStore((state) => state.scenarioInterval?.end)!;
  const left = calcPosition(startTijd, timeLineBegin, timeLineEnd, scale);
  const width = calcWidth(startTijd, eindTijd, timeLineEnd, scale);
  const timeText = startTijd?.minute + "–" + eindTijd?.minute;
  const voorNaTijdClass = isVoorTijd ? styles["voor-tijd-lijn"] : styles["na-tijd-lijn"];

  return (
    width > 0 && (
      <div
        style={{
          width: width,
          left: left,
        }}
        className={styles["voor-na-tijd-container"] + " " + voorNaTijdClass}
      >
        <div className={styles["voor-na-tijd-tijd"]}>{timeText}</div>
      </div>
    )
  );
}
